import { createFileRoute } from '@tanstack/react-router';

import { PlatformAssessmentListScreen } from '@/features/assessments/components/platform/AssessmentListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/assessments/')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: PlatformAssessmentListScreen,
  staticData: { crumb: 'Assessments' },
});
